module.exports = __webpack_public_path__ + "img/avatar-s-20.05713ba4.jpg";